import { render } from "./IdaasDescription.vue?vue&type=template&id=1a7f40da"
import script from "./IdaasDescription.vue?vue&type=script&lang=js"
export * from "./IdaasDescription.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__